import { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import Snackbar from "../components/snackbar/Snackbar";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [snack, setSnack] = useState({
    type: "success",
    message: "",
    open: false
  });

  const handleCloseSnack = () => {
    setSnack({
      type: "success",
      message: "",
      open: false
    });
  };

  return (
    <AlertContext.Provider value={setSnack}>
      {children}
      <Snackbar snack={snack} onClose={handleCloseSnack} />
    </AlertContext.Provider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.node
};

export const useSnack = () => useContext(AlertContext);
